import { Injectable } from '@angular/core';
import { UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, Route } from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';
import { RtbAuthService } from 'src/app/auth/rtb-auth.service';

@Injectable({
  providedIn: 'root'
})
export class ReportBuilderSubscriptionGuard {
  constructor(
    private router: Router,
    private authService: RtbAuthService
  ) { }

  private readonly redirectUrl = '/access-page';

  public canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkApplicationAccess();
  }

  public canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkApplicationAccess();
  }

  public canLoad(
    _route: Route,
    _segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkApplicationAccess();
  }

  private async checkApplicationAccess(): Promise<boolean> {
    try {
      const hasAccess = await firstValueFrom(this.authService.hasAccessToApplication$);

      if (!hasAccess) {
        this.router.navigateByUrl(this.redirectUrl);
      }
      return hasAccess;
    } catch (error) {
      console.error(error);
      this.router.navigateByUrl(this.redirectUrl);
      return false;
    }
  }
}
